import { cn } from "@/lib/utils";

import type { Category } from "../api";

const STYLES: Record<Category, string> = {
  new: "bg-warning-light text-warning border-warning/40",
  enhancement: "bg-success-light text-success border-success/40",
  fix: "bg-danger-light text-danger border-danger/40",
};

const LABELS: Record<Category, string> = {
  new: "New",
  enhancement: "Enhancement",
  fix: "Fix",
};

export function CategoryBadge({
  category,
  className,
}: {
  category: Category;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider",
        STYLES[category],
        className,
      )}
    >
      {LABELS[category]}
    </span>
  );
}
